import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbEnseigne } from '@/models/alodb/AloDbEnseigne'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import slugify from 'slugify/slugify'

export default {
  getEnseignes(): AxiosPromise<AlrContainer<AloBaseArray<AloDbEnseigne>>> {
    return apiHelpers.apiCall({
      url: 'api/admin/enseigne',
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloBaseArray<AloDbEnseigne>>(JSON.parse(data), AloDbEnseigne.createAloDbEnseigneArray)
        },
      ],
    })
  },
  getEnseigne(id: number): AxiosPromise<AlrContainer<AloDbEnseigne>> {
    return apiHelpers.apiCall({
      url: `api/admin/enseigne/${id}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloDbEnseigne>(JSON.parse(data), AloDbEnseigne.createAloDbEnseigneWithDetail)
        },
      ],
    })
  },
  saveEnseigne(enseigne: AloDbEnseigne): AxiosPromise<AlrContainer<AloDbEnseigne>> {
    if (enseigne.ENS_ID && enseigne.ENS_ID > 0) {
      enseigne.ENS_CONFIG_JSON = JSON.stringify(enseigne.config)
      enseigne.ENS_ADCP_ON = enseigne.config.ad2cp_on
      return apiHelpers.apiCall({
        url: `api/admin/enseigne/${enseigne.ENS_ID}`,
        method: 'PUT',
        data: enseigne,
        transformResponse: [
          function (data: string) {
            return new AlrContainer<AloDbEnseigne>(JSON.parse(data), AloDbEnseigne.createAloDbEnseigneWithDetail)
          },
        ],
      })
    } else {
      enseigne.ENS_KEY = slugify(enseigne.ENS_LIBELLE ?? '', { lower: true, replacement: '_', strict: true })
      return apiHelpers.apiCall({
        url: `api/admin/enseigne`,
        method: 'POST',
        data: enseigne,
        transformResponse: [
          function (data: string) {
            return new AlrContainer<AloDbEnseigne>(JSON.parse(data), AloDbEnseigne.createAloDbEnseigneWithDetail)
          },
        ],
      })
    }
  },
}
